import { blue } from 'theme/colors';
import { Box } from '@mui/material';
import { IconFileDownload } from '@tabler/icons-react';
import { ActionButton } from '@atoms';
import useGetPartnerTransactionReceipt from '@modules/transferReceipt/data/useGetPartnerTransactionReceipt';
import { Receipt } from '@modules/transferReceipt/data/useGetPartnerTransactions';

/**
 * Buttons on action column on table
 * @param row row data of the table, used to get the id for downloading the receipt of a transaction
 */
export default function ActionButtons({ row }: { row: Receipt }) {
  const { download } = useGetPartnerTransactionReceipt();
  return (
    <Box display={'flex'} justifyContent={'space-around'}>
      <ActionButton
        {...{
          show: true,
          tooltip: 'COMMON:EXPORT',
          icon: <IconFileDownload color={blue.main} />,
          callback: () => download(row),
        }}
      />
    </Box>
  );
}
